"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPartnerHostedLivestreamCtaUrlProperty = exports.partnerHostedLivestreamCtaUrlPropertyDefinition = void 0;
exports.partnerHostedLivestreamCtaUrlPropertyDefinition = {
    view: { label: 'CTA livestream URL' },
    constraints: [
        {
            name: 'orderedProperties',
            argument: ['cta-button-label', 'cta-url-link'],
        },
    ],
    type: 'ordered-container',
    multiple: true,
    name: 'partner-hosted-livestream-cta-url',
};
const isPartnerHostedLivestreamCtaUrlProperty = (prop) => {
    return prop.name === exports.partnerHostedLivestreamCtaUrlPropertyDefinition.name;
};
exports.isPartnerHostedLivestreamCtaUrlProperty = isPartnerHostedLivestreamCtaUrlProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicGFydG5lci1ob3N0ZWQtbGl2ZXN0cmVhbS1jdGEtdXJsLnByb3BlcnR5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3Byb3BlcnRpZXMvcGFydG5lci1ob3N0ZWQtbGl2ZXN0cmVhbS1jdGEtdXJsLnByb3BlcnR5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVhLFFBQUEsK0NBQStDLEdBQUc7SUFDN0QsSUFBSSxFQUFFLEVBQUUsS0FBSyxFQUFFLG9CQUFvQixFQUFFO0lBQ3JDLFdBQVcsRUFBRTtRQUNYO1lBQ0UsSUFBSSxFQUFFLG1CQUFtQjtZQUN6QixRQUFRLEVBQUUsQ0FBQyxrQkFBa0IsRUFBRSxjQUFjLENBQUM7U0FDL0M7S0FDRjtJQUNELElBQUksRUFBRSxtQkFBbUI7SUFDekIsUUFBUSxFQUFFLElBQUk7SUFDZCxJQUFJLEVBQUUsbUNBQW1DO0NBQ1YsQ0FBQTtBQUkxQixNQUFNLHVDQUF1QyxHQUFHLENBQUMsSUFBa0IsRUFBaUQsRUFBRTtJQUMzSCxPQUFPLElBQUksQ0FBQyxJQUFJLEtBQUssdURBQStDLENBQUMsSUFBSSxDQUFBO0FBQzNFLENBQUMsQ0FBQTtBQUZZLFFBQUEsdUNBQXVDLDJDQUVuRCJ9